import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppContext } from '../../AppContext'; // adjust the path if needed

const Advertisement = () => {
    const { appState } = useContext(AppContext);
    const { subtext, heading, buttons } = appState.advertisement || {};

    if (!buttons?.[0]) {
        return
    }


    return (
        <section className="section-padding LOANLY-advertisement parallax">
            <div className="row">
                <div className="col-12">
                    <div className="advertisement-text text-center">
                        <p className="text-white fs-20">{subtext}</p>
                        <h3 className="text-white">{heading}</h3>
                        <div className="btn-group">
                            {buttons.map((btn, index) => (
                                <Link
                                    key={index}
                                    to={btn.link}
                                    className={`btn-first ${btn.variant} fw-600 mb-xs-20`}
                                >
                                    {btn.label}
                                </Link>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Advertisement;
